import { getConfig } from "../lib/configMgr";
import { toJSON, RequestBuilder } from "./request";
import {toast} from "react-toastify";
import {CORSError} from "./errors";

const { ExternalRESTAPI, AWSCognito: { region, userPoolID, clientID } } = getConfig();

export const fetchVersionData = (verbose = false, auth = null) => {
  const url = new URL(ExternalRESTAPI.VersionInfo, window.location.origin);
  if (verbose) {
    url.searchParams.set('verbose', "true");
  }
  const req = new RequestBuilder(url);
  if (auth) {
    req.withAuthorization(auth);
  }

  return req.fetch()
    .then(toJSON)
    .then(data => ({
        ...data,
        userPoolID: data.pool_id,
        clientID: data.client_id
    }))
    .catch(error => {
      if (error instanceof CORSError) {
        const msg = "CORS error: Check server configuration and allowed headers";
        console.error(msg, error.details);
        toast.error(msg);
        return {
          ready: null,
          region,
          userPoolID,
          clientID,
        };
      }
      if (error instanceof TypeError) {
        const msg = "Server is unavailable, try again later";
        console.warn(msg);
        toast.warning(msg);
        return {
          ready: null,
          region,
          userPoolID,
          clientID,
        };
      }
      console.debug(`Version fetch error ${error}`);
      throw error;
    });
};

export const reload = (params = {}, auth = null) => {
  const url = new URL(ExternalRESTAPI.Reload, window.location.origin);
  Object.entries(params).forEach(([k, v]) => {
    url.searchParams.set(k, v);
  });
  const req = new RequestBuilder(url);
  if (auth) {
    req.withAuthorization(auth);
  }
  return req.asPOST().fetch().then(toJSON).catch(err => {});
};

export const flushCache = (auth = null) => {
  return reload({cache: true}, auth);
};
